import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ds-lib-profile-bar',
  templateUrl: './ds-lib-profile-bar.component.html',
  styleUrls: ['./ds-lib-profile-bar.component.scss'],
})
export class DsLibProfileBarComponent {
  /**
   * Main info, will be displayed in bold
   */
  @Input() public mainInfo: string;

  /**
   * Secondary info, displayed below the main info, in smaller text
   */
  @Input() public subInfo: string;

  /**
   * Information to say to the component if he need to show the short or long version of itself
   */
  @Input() public isExpanded: boolean;

  /**
   * Event emitted when clicking on the account info element (left side)
   */
  @Output() private accountClicked = new EventEmitter();

  /**
   * Creates an instance of DsLibProfileBarComponent.
   */
  constructor() {
    this.mainInfo = '';
    this.subInfo = '';
    this.isExpanded = true;
  }

  /**
   * Emits onAccountClicked event.
   */
  public onAccountClicked() {
    this.accountClicked.emit();
  }
}
